module.exports = __webpack_public_path__ + "static/media/footer_logo.7ece3234.png";